exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-pb-job-types{max-width:720px}.c-pb-job-types .m-form-group{margin-bottom:12px}.c-pb-job-types_hint{font-size:12px;color:#112363;margin:0 0 8px}.c-pb-job-types .c-job-type-modal-table>.row{margin-top:4px}.c-pb-job-types .c-job-type-modal-table>.row.header{margin-top:0}.c-pb-job-types .c-job-type-modal-table>.row.header div{font-size:11px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;opacity:.55}.c-pb-job-types .c-job-type-modal-table_warning .text{font-size:12px}", ""]);

// exports
